<app-page-header title="Verksamhetsdetaljer" icon="description"></app-page-header>
<div [@fadeInOut] class="page-content">
  <mat-tab-group>
    <mat-tab label="Allmänt">
      <form #form="ngForm" [formGroup]="businessForm" (ngSubmit)="save()" novalidate class="flex-col gap-1em" autocomplete="off">
        <mat-card appearance="outlined">
          <mat-card-content>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Organisation</mat-label>
                <mat-select formControlName="organizationId" required [disabled]="!isNew">
                  <mat-option>{{ 'globalTexts.ChooseInstruction' | translate }}</mat-option>
                  @for (entry of organizations$ | async; track entry) {
                    <mat-option [value]="entry.item1">
                      {{ entry.item2 }}
                    </mat-option>
                  }
                </mat-select>
                @if (getFormControl('organizationId').hasError('required')) {
                  <mat-error>Organisation är obligatorisk</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="flex-1">
                <mat-label>Verksamhetsnamn</mat-label>
                <input matInput formControlName="name" required />
                @if (getFormControl('name').hasError('required')) {
                  <mat-error>Verksamhetsnamn är obligatoriskt</mat-error>
                }
                @if (getFormControl('name').hasError('maxlength')) {
                  <mat-error>Verksamhetsnamn får inte innehålla mer än 100 tecken</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Verksamhetskategori</mat-label>
                <mat-select formControlName="businessCategoryId" required>
                  <mat-option>{{ 'globalTexts.ChooseInstruction' | translate }}</mat-option>
                  @for (entry of businessCategories$ | async; track entry) {
                    <mat-option [value]="entry.item1">
                      {{ entry.item2 }}
                    </mat-option>
                  }
                </mat-select>
                @if (getFormControl('businessCategoryId').hasError('required')) {
                  <mat-error>Verksamhetskategori är obligatorisk</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="flex-1">
                <mat-label>Region</mat-label>
                <mat-select formControlName="regionId" placeholder="">
                  <mat-option>{{ 'globalTexts.ChooseInstruction' | translate }}</mat-option>
                  @for (entry of regions$ | async; track entry) {
                    <mat-option [value]="entry.item1">
                      {{ entry.item2 }}
                    </mat-option>
                  }
                </mat-select>
                @if (getFormControl('regionId').hasError('required')) {
                  <mat-error>Region är obligatorisk</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Ägare</mat-label>
                <mat-select formControlName="ownedBy">
                  <mat-option>{{ 'globalTexts.ChooseInstruction' | translate }}</mat-option>
                  @for (entry of users$ | async; track entry) {
                    <mat-option [value]="entry.item1">
                      {{ entry.item2 }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <div class="flex-1">
                <mat-checkbox formControlName="enabled">Aktiv</mat-checkbox>
              </div>
            </div>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Gatuadress</mat-label>
                <input matInput formControlName="streetAddress" />
                @if (getFormControl('streetAddress').hasError('maxlength')) {
                  <mat-error>Gatuadress kan inte innehålla mer än 200 tecken</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="flex-1">
                <mat-label>Postnr</mat-label>
                <input matInput formControlName="zipCode" />
                @if (getFormControl('zipCode').hasError('maxlength')) {
                  <mat-error>Postnr kan inte innehålla mer än 50 tecken</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Postadress</mat-label>
                <input matInput formControlName="postalAddress" />
                @if (getFormControl('postalAddress').hasError('maxlength')) {
                  <mat-error>Postadress kan inte innehålla mer än 100 tecken</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="flex-1">
                <mat-label>Kontaktperson</mat-label>
                <input matInput formControlName="contactPerson" />
                @if (getFormControl('contactPerson').hasError('maxlength')) {
                  <mat-error>Kontaktperson kan inte innehålla mer än 200 tecken</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Telefon</mat-label>
                <input matInput formControlName="phone" />
                @if (getFormControl('phone').hasError('maxlength')) {
                  <mat-error>Telefon kan inte innehålla mer än 30 tecken</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="flex-1">
                <mat-label>E-post</mat-label>
                <input matInput formControlName="email" />
                @if (getFormControl('email').hasError('maxlength')) {
                  <mat-error>E-post kan inte innehålla mer än 100 tecken</mat-error>
                }
                @if (getFormControl('email').hasError('pattern')) {
                  <mat-error>Felaktig e-postadress</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Webbsida</mat-label>
                <input matInput formControlName="siteUrl" />
                @if (getFormControl('siteUrl').hasError('maxlength')) {
                  <mat-error>Webbsida kan inte innehålla mer än 200 tecken</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Beskrivning</mat-label>
                <textarea rows="4" matInput formControlName="description" placeholder=""></textarea>
              </mat-form-field>
            </div>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Latitud</mat-label>
                <input matInput type="number" formControlName="latitude" />
              </mat-form-field>
              <mat-form-field class="flex-1">
                <mat-label>Longitud</mat-label>
                <input matInput type="number"  formControlName="longitude" />
              </mat-form-field>
            </div>

            @if (!isNew) {
              <div class="flex-row flex-col-ltmd gap-col-1em">
                <mat-form-field class="flex-1">
                  <mat-label>Senaste datum för godkänd rapport</mat-label>
                  <input matInput type="date" formControlName="latestApprovedReportDate" [readonly]="true" />
                </mat-form-field>
                <mat-form-field class="flex-1">
                  <mat-label>Tidigare datum för godkänd rapport</mat-label>
                  <input matInput type="date" formControlName="previousApprovedReportDate" [readonly]="true" />
                </mat-form-field>
              </div>
            }
            @if (!isNew) {
              <div class="flex-row flex-col-ltmd gap-col-1em">
                <mat-form-field class="flex-1">
                  <mat-label>Bedömning</mat-label>
                  <input matInput formControlName="latestScoreLevel" [readonly]="true" />
                </mat-form-field>
                <mat-form-field class="flex-1">
                  <mat-label>Tidigare bedömning</mat-label>
                  <input matInput formControlName="previousScoreLevel" [readonly]="true" />
                </mat-form-field>
              </div>
            }
            @if (!isNew) {
              <div class="flex-row flex-col-ltmd gap-col-1em">
                <mat-form-field class="flex-1">
                  <mat-label>Skapad av</mat-label>
                  <input matInput value="{{ createdByName$ | async }}" [readonly]="true" />
                </mat-form-field>
                <mat-form-field class="flex-1">
                  <mat-label>Skapad</mat-label>
                  <input matInput formControlName="createdDate" [readonly]="true" />
                </mat-form-field>
              </div>
            }
            @if (!isNew) {
              <div class="flex-row flex-col-ltmd gap-col-1em">
                <mat-form-field class="flex-1">
                  <mat-label>Uppdaterad av</mat-label>
                  <input matInput value="{{ changedByName$ | async }}" [readonly]="true" />
                </mat-form-field>
                <mat-form-field class="flex-1">
                  <mat-label>Uppdaterad</mat-label>
                  <input matInput formControlName="updatedDate" [readonly]="true" />
                </mat-form-field>
              </div>
            }
            @if (!isNew) {
              <div class="flex-row flex-col-ltmd gap-col-1em">
                <mat-form-field class="flex-1">
                  <mat-label>Verksamhet Id</mat-label>
                  <input matInput formControlName="businessId" [readonly]="true" />
                </mat-form-field>
              </div>
            }
          </mat-card-content>
          <mat-card-actions>
            <section class="button-container">
              @if (hasPermissionToChange()) {
                <button type="submit" mat-fab color="primary" title="{{'commands.Save' | translate }}"><mat-icon>done</mat-icon></button>
              }
              <button type="button" mat-fab (click)="cancel()" color="warn" title="{{'commands.Cancel' | translate }}"><mat-icon>arrow_back</mat-icon></button>
            </section>
          </mat-card-actions>
        </mat-card>
      </form>
    </mat-tab>
    @if (!isNew) {
      <mat-tab label="Rapporter">
        <app-report-list [businessId]="id" [showTitle]="false"></app-report-list>
      </mat-tab>
    }
  </mat-tab-group>

</div>
